export const ENTITY_TYPE_ORGANIZATION = 'Organization';
export const ENTITY_TYPE_TOPIC = 'Topic';
export const ENTITY_TYPE_PERSON = 'Person';
export const ENTITY_TYPE_BLOG = 'Blog';
export const ENTITY_TYPE_COURSE = 'Course';
export const ENTITY_TYPE_APP = 'App';
export const ENTER_KEY = 13;
export const CATEGORY = 'Category';
export const TOOLKIT = 'Toolkit';
export const IDENTITY = 'Identity';
export const CONTENT_TYPES = {
  WIKIPEDIA: 'wikipedia_page',
  EXECUTIVE_SUMMARY: 'executive_summary',
  BOOK: 'book',
  VIDEO: 'video',
  ARTICLE: 'article',
  WEBSITE: 'website',
  SOCIAL_MEDIA: 'social_media',
  BLOG: 'blog',
  POEM: 'poem',
  COURSE: 'course',
  PODCAST: 'podcast',
  PHOTO: 'photo',
  EVENT: 'event',
  QUOTE: 'quote',
  MOVIE: 'movie',
  APP: 'app',
  USER_FEED: 'user_feed',
  QUESTION: 'question',
  WEBINAR: 'webinar',
};
export const NOT_ASSIGNED = 'Not Assigned';
export const ON_DEMAND_UNCHECK_MSG = (type: String) =>
  `Are you sure you want to make this as a scheduled ${type}? If yes, then existing post will be deleted`;

export const USER_CONTENT_STAFF = 'content_staff';
export const CONTENT_INAPPROPRIATE_WARNING_MESSAGE =
  'This will delete all associated tags and ensure that this content will not appear on the front end website';
export const IMPORTANT = 'Important';
export const HIGH = 'High';

export const MAX_SLUG_LENGTH = 40;
export const PODCAST_SERVICE_PROVIDERS = {
  SPOTIFY: 'Spotify',
  APPLE: 'Apple',
  OTHERS: 'Others',
};
export const PRACTITIONER = 'Practitioner';

export const MarketingPlatforms = [
  { id: 1, name: 'YouTube' },
  { id: 2, name: 'Facebook' },
  { id: 3, name: 'Instagram' },
  { id: 4, name: 'LinkedIn' },
  { id: 5, name: 'Twitter' },
];

export const Platforms = [
  { id: 'all', label: 'All', value: 'All' },
  { id: 'instagram', label: 'Instagram', value: 'Instagram' },
  { id: 'facebook', label: 'Facebook', value: 'Facebook' },
  { id: 'youtube', label: 'YouTube', value: 'YouTube' },
  { id: 'linkedin', label: 'LinkedIn', value: 'LinkedIn' },
  { id: 'twitter', label: 'Twitter', value: 'Twitter' },
];

export const MarketingPlatformCategories = [
  { id: 1, name: 'Shorts' },
  { id: 2, name: 'Regular' },
];

export const Themes = [
  { id: 1, name: 'Travel' },
  { id: 2, name: 'Fun' },
  { id: 3, name: 'Learn' },
];

export const Categories = [
  { id: 1, name: 'India Series' },
  { id: 2, name: 'Life Lessons' },
  { id: 3, name: 'Timeline of Memories' },
  { id: 4, name: 'Life in Motion' },
];

export const UserRoles = [
  { id: 5, name: 'CREATIVE EDITOR', value: 'creative_editor' },
  { id: 6, name: 'CONTENT SPECIALIST', value: 'content_specialist' },
  { id: 7, name: 'MARKETER', value: 'marketer' },
];

export const ADD_CONTENT_ALLOWED_ROLES = ['editor', 'admin', 'creative_editor'];

export const StatusProps = [
  { id: 1, value: 'Published', name: 'processed' },
  { id: 2, value: 'Scheduled', name: 'scheduled' },
  { id: 3, value: 'Draft', name: 'pending' },
];
